import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Invoice } from '../../../invoice/models/dtos/invoice.model';

@Component({
  selector: 'kt-app-invoice-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './invoice-summary.component.html',
  styleUrls: ['./invoice-summary.component.scss']
})
export class InvoiceSummaryComponent {
  @Input() invoice?: Invoice;
}
